import { Config } from 'final-form';
import { Component, Vue } from 'vue-property-decorator';

@Component({
    props: ['onSubmit'],
    template: require('./login-form.html'),
})
export class LoginForm extends Vue {
    public onSubmit: Config['onSubmit'];

    public async mounted() {
        localStorage.removeItem("token")
        localStorage.removeItem("userId")
        localStorage.removeItem("workspace")
        localStorage.removeItem("institution")
        const preferredLocale = localStorage.getItem("preferredLocale")
        if (preferredLocale) {
            this.$i18n.locale = preferredLocale;
        }
    }

    public validate(values): Promise<object> {
        return new Promise(resolve => {
            // need to be a promise to avoid conflict with $t mixin
            const errors = {} as any;

            if (!values.username) {
                errors.username = this.$t('auth.login.form.username.error');
            }

            if (!values.password) {
                errors.password = this.$t('auth.login.form.password.error');
            }

            resolve(errors);
        });
    }
}
